import { useRouter } from "next/router";
import { useEffect } from "react";
import { OneColumnContainer } from "../../components/ColumnContainers/OneColumnContainer";
import Layout from "../../components/Layout";
import { PoolDetail } from "../../components/PoolDetail";
import Protected from "../../components/Protected";

const Pool = () => {
  const router = useRouter();
  useEffect(() => {
    if (!router.isReady) return;

    // codes using router.query
  }, [router.isReady]);

  const { id } = router.query;
  return <PoolDetail id={id} />;
};

Pool.getLayout = (page) => (
  <>
    <Layout title="GolfChamps | Pool">
      <Protected>
        <OneColumnContainer>{page}</OneColumnContainer>
      </Protected>
    </Layout>
  </>
);

export default Pool;
